import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { OrganisationGroupReferenceModel } from "../../models/organisation-model/organisation-group-reference.model";

@Injectable({
    providedIn: 'root'
})
export class OrganisationGroupReferenceService extends ApiServiceBase {
    private readonly ORGANISATION_PATH = "/organisation"
    constructor( 
        private httpClient: HttpClient,
        private authService: AuthService
    ) {
        super(httpClient, authService);
    }

    public searchOrganisationGroup(organisationGroupCode: string): Observable<OrganisationGroupReferenceModel[]> {
        let params = new HttpParams()
          .set("code", organisationGroupCode);
    
        return this.httpGet<any>(this.ORGANISATION_PATH + "/organisationGroupReferences", params)
          .pipe(
            map(response => {
              return response.body;
            })
          );
    }
}